export { default as AdvicePage } from './AdvicePage';
export { default as ArticleDetailPage } from './ArticleDetailPage';
export { default as BasicPage } from './BasicPage';
export { default as EventPage } from './EventPage';
export { default as NewsPage } from './NewsPage';
export { default as NotFoundPage } from './NotFoundPage';
export { default as ProductPage } from './ProductPage';
export { default as OwnerDetailPage } from './OwnerDetailPage';
